module.exports = __webpack_public_path__ + "static/media/report-white-small.7fbfa13b.svg";